import { deviceDetect } from 'react-device-detect';
import { getRoomIdFromLocation } from '@web-chat-core/ui-kit/helpers/getRoomIdFromLocation';

const { REACT_APP_SSO_URL, REACT_APP_AUTH_APP, REACT_APP_AUTH_SECRET } = process.env;

const getRedirectUrl = (): string => {
    const roomId = getRoomIdFromLocation();
    return `${window.location.origin}/${roomId}`;
};

/**
 * @returns URL like:
 * - http://localhost:3000/oauth?browser=Chrome&app=meet&secret=XXXYYY&redirectUrl=https://call-stage4.softhub.dev/af416810-e4ad-79f6-6cfa-319dd0b3db98
 * - https://web-stage4.softhub.dev/oauth?browser=Safari&app=meet&secret=XXXYYY&redirectUrl=https://call-stage4.softhub.dev/af416810-e4ad-79f6-6cfa-319dd0b3db98
 */
const getSsoAuthorizationUrl = () => {
    const { browserName } = deviceDetect(window.navigator.userAgent);

    const redirectUrl = getRedirectUrl();

    return `${REACT_APP_SSO_URL}?browser=${browserName}&app=${REACT_APP_AUTH_APP}&secret=${REACT_APP_AUTH_SECRET}&redirectUrl=${redirectUrl}`;
};

export const redirectToSsoAuthorization = () => {
    window.location.href = getSsoAuthorizationUrl();
};
